import {
    WS_CONNECTED,
    WS_DISCONNECTED,
    WS_RECONNECTING,
    WS_ERROR,
} from '../actions/websocketActions';

// ws connection statuses: 'connecting' | 'connected' | 'reconnecting' | 'disconnected' | 'error'
const initialState = {
    status: 'disconnected',
    lastError: null,
    reconnectAttempts: 0,
    connectedAt: null,
};

export default function websocket(state = initialState, action) {
    switch (action.type) {
        case WS_CONNECTED:
            return {
                ...state,
                status: 'connected',
                lastError: null,
                reconnectAttempts: 0,
                connectedAt: Date.now(),
            };
        case WS_DISCONNECTED:
            return { ...state, status: 'disconnected' };
        case WS_RECONNECTING:
            return {
                ...state,
                status: 'reconnecting',
                reconnectAttempts: state.reconnectAttempts + 1,
            };
        case WS_ERROR:
            return { ...state, status: 'error', lastError: action.payload };
        default:
            return state;
    }
}
